import MediaQueries from 'shared/helpers/MediaQueries';
import LoadStylesService from './LoadStylesService';

/*
 * Load style CSS for correct device
 * */
export default class ResponsiveService {
  static styleCreated = false;

  static timeout: NodeJS.Timeout;

  static styleHeadPageElt: HTMLElement =
    document.getElementById('js-stylePage');

  static readonly delay = 250;

  static readonly initDevice: string =
    ResponsiveService.styleHeadPageElt.dataset.device;

  constructor() {
    document.addEventListener(
      'DOMContentLoaded',
      ResponsiveService.getStyelsheetLoadPage,
      { passive: true }
    );
    window.addEventListener('resize', ResponsiveService.resizeWindow, {
      passive: true,
    });
  }

  /*
   * Window resize event listener
   * */
  private static resizeWindow(): void {
    clearTimeout(ResponsiveService.timeout);

    // Get dimensions if style not added
    if (!ResponsiveService.styleCreated) {
      // Add delay after event is "complete" to run callback
      ResponsiveService.timeout = setTimeout(
        ResponsiveService.getStyelsheetResizePage,
        ResponsiveService.delay
      );
    }
  }

  /*
   * Load correct css after window loaded
   * */
  private static getStyelsheetLoadPage(): void {
    if (
      MediaQueries.mobileMedia.matches &&
      ResponsiveService.initDevice !== 'mobile'
    ) {
      ResponsiveService.loadStyles();
    }
    if (MediaQueries.md.matches && ResponsiveService.initDevice !== 'tablet') {
      ResponsiveService.loadStyles();
    }
    if (
      MediaQueries.desktopMedia.matches &&
      ResponsiveService.initDevice !== 'desktop'
    ) {
      ResponsiveService.loadStyles();
    }

    // Clear event listener
    document.removeEventListener(
      'DOMContentLoaded',
      ResponsiveService.getStyelsheetLoadPage
    );
  }

  /*
   * Load correct css for resize window
   * */
  private static getStyelsheetResizePage(): void {
    // Add style desktop and tablet on resize if start to mobile
    if (
      !MediaQueries.mobileMedia.matches &&
      ResponsiveService.initDevice === 'mobile'
    ) {
      ResponsiveService.loadStyles();
    }

    // Add style desktop and mobile on resize if start to tablet
    if (
      !MediaQueries.tabletMedia.matches &&
      ResponsiveService.initDevice === 'tablet'
    ) {
      ResponsiveService.loadStyles();
    }

    // Add style mobile an tablet on resize if start to desktop
    if (
      !MediaQueries.desktopMedia.matches &&
      ResponsiveService.initDevice === 'desktop'
    ) {
      ResponsiveService.loadStyles();
    }
  }

  /*
   * LoadStyles
   * */
  private static loadStyles(): void {
    const { href, media, hrefOther, mediaOther } =
      ResponsiveService.styleHeadPageElt.dataset;

    ResponsiveService.styleCreated = LoadStylesService.loaderStyle(href, media);
    ResponsiveService.styleCreated = LoadStylesService.loaderStyle(
      hrefOther,
      mediaOther
    );

    // Load CSS for footer
    ResponsiveService.loadAllResponsiveStyles();

    // Clear event listener
    window.removeEventListener('resize', ResponsiveService.resizeWindow);
  }

  /*
   * Load all responsive styles in page
   * */
  private static loadAllResponsiveStyles(): void {
    const allStylesElt: NodeListOf<HTMLLinkElement> =
      document.querySelectorAll('.js-stylePageDefer');

    if (allStylesElt.length > 0) {
      allStylesElt.forEach((stylesElt: HTMLLinkElement) => {
        const { href, media, hrefOther, mediaOther } = stylesElt.dataset;

        ResponsiveService.styleCreated = LoadStylesService.loaderStyle(
          href,
          media
        );
        ResponsiveService.styleCreated = LoadStylesService.loaderStyle(
          hrefOther,
          mediaOther
        );
      });
    }
  }
}
